import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Container } from "shared/UI/LayoutComponents/LayoutComponents";
import { ViewStateWrapper } from "UIPalette/ViewStateWrapper/ViewStateWrapper";
import { useGetUserHubLinksFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { WellKnownHubModules } from "../../wellKnownHubModules";
import { OtherSiteCard } from "./OtherSiteCard";

interface OtherSitesModuleProps {
  index: number;
  hasPreviousVisibleModule?: boolean;
}

export const OtherSitesModule = ({ index, hasPreviousVisibleModule = true }: OtherSitesModuleProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: "studentHub.otherSites" });

  const { data, isLoading, error, mutate } = useGetUserHubLinksFunctionRequest({
    moduleKey: WellKnownHubModules.studentHub,
    xClientCode: ClientInfoState.getCode(),
  });

  const hubLinks = data?.hubLinks;
  const hasLinks = !!hubLinks?.length;
  const showTopBorder = index !== 0 && hasPreviousVisibleModule;

  const header = (
    <Container className={classNames("!h-auto !my-0 !px-0", { "!pt-12 border-t-none lg:border-t border-brand-grey-light": showTopBorder })}>
  <h2 className="!p-0">{t("heading")}</h2>
    </Container>
  );

  const cardsLayout = (
    <Container className="!mt-4 !px-0">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-6">
        {hubLinks?.map((hubLink) => (
          <OtherSiteCard key={hubLink.id} hubLink={hubLink} />
        ))}
      </div>
    </Container>
  );

  if (!hasLinks) return null;

  return (
    <div
      data-testid="other-sites-module"
      className={classNames("mt-12 lg:mt-16", { "border-t lg:border-none border-brand-grey-light": showTopBorder })}
    >
      <div className={classNames({ "flex flex-col items-center w-full justify-center py-10": isLoading || !!error })}>
        <ViewStateWrapper errorMessage={t("errorMessage")} onRetry={mutate} loading={isLoading} error={!!error}>
          {header}
          {cardsLayout}
        </ViewStateWrapper>
      </div>
    </div>
  );
};
